import React, { ElementType, HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLOrSVGElement> {
  data: ReusableTextField;
  as?: ElementType;
}

function TextComponent({
  data,
  className = '',
  as: Tag = 'p',
  ...rest
}: Props) {
  if (!data) {
    return null;
  }
  const isGradient = data.input_font_color?.includes('gradient');
  const combinedClassName =
    `${className} ${isGradient ? 'gradient-text' : ''}`.trim();

  return (
    <Tag
      dangerouslySetInnerHTML={{ __html: data.input_text || '' }}
      style={{
        fontSize: data.input_font_size ? `${data.input_font_size}rem` : '',
        lineHeight: data.input_line_height || '',
        ...(data.input_font_color && !isGradient
          ? { color: data.input_font_color }
          : {}),
        ...(data.input_font_color && isGradient
          ? { '--gradient': data.input_font_color }
          : {}),
        marginTop: data.margin_top ? `${data.margin_top}rem` : '',
        marginBottom: data.margin_bottom ? `${data.margin_bottom}rem` : '',
      }}
      className={combinedClassName}
      {...rest}
    ></Tag>
  );
}

export default TextComponent;
